import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { v4 as uuidv4 } from 'uuid';
import ModuleCreatorModule, { Props } from '../_components/ModuleCreatorModule';
import { OnModuleAdd } from '../../ModuleList/_actions/ModuleListActions';
import { ModuleTypes } from '../../Module/_config/ModuleInfo';
import { ModuleOnValueUpdate } from '../../Module/_actions/ModuleActions';

const mapDispatchToProps = (dispatch:Dispatch, props:Props) => ({
	onModuleAdd: (type:ModuleTypes) => {
		dispatch(OnModuleAdd(uuidv4(), type))
	},
	onModuleAddWithValue: (moduleType:ModuleTypes, key: string, value:boolean | string | number) => {
		let moduleId = uuidv4();
		dispatch(OnModuleAdd(moduleId, moduleType)),
		dispatch(ModuleOnValueUpdate(moduleId, key, value))
	}
});

export default connect(
	null,
	mapDispatchToProps
)(ModuleCreatorModule);